/*
 *  Featured Products
 *    Scripts for the featured products carousel
 *
 *  Version:
 *    1.0.0 - 2022/02/17
 */

import { CLASS_INITIALISED } from '../../tools/constants/classes';
import { initCarousel, InitCarouselParams } from '../../objects/carousel';
import { responsiveQuery } from '../../settings/responsive';

const SELECTOR_CONTAINER = '[data-featured-products]';
const SELECTOR_CAROUSEL = '[data-featured-products-carousel]';
const SELECTOR_NAV = '[data-featured-products-nav]';

document
  .querySelectorAll<HTMLElement>(SELECTOR_CONTAINER)
  .forEach((container) => {
    // Check if section has already been initialized
    if (container.classList.contains(CLASS_INITIALISED)) return;
    container.classList.add(CLASS_INITIALISED);

    const carouselElement =
      container.querySelector<HTMLElement>(SELECTOR_CAROUSEL);
    const nav = container.querySelector<HTMLElement>(SELECTOR_NAV);
    const options = {
      slidesPerView: 1.5,
      spacing: 24,
      loop: true,
      centered: true,
      breakpoints: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '(min-width: 550px)': {
          slidesPerView: 1.8,
        },
        [responsiveQuery('SMALL')]: {
          slidesPerView: 2.4,
        },
        [responsiveQuery('MEDIUM')]: {
          slidesPerView: 2.9,
          spacing: 32,
        },
        [responsiveQuery('LARGE')]: {
          slidesPerView: 3.3,
          spacing: 32,
        },
        [responsiveQuery('XLARGE')]: {
          slidesPerView: 3.65,
          spacing: 32,
        },
      },
    };
    if (!carouselElement) return;

    const params: InitCarouselParams = {
      container: carouselElement,
      navigationContainer: nav,
      options,
    };
    const carousel = initCarousel(params);
  });
